import { IApiUser, MfaMode } from 'src/models/users/types';
import { Country, PaymentRole, Role } from '@tendium/prom-types';

export interface ApiAdminUser extends IApiUser {
  role: Role;
  roles: Role[];
  companyRole: string;
  isAdmin: boolean;
  createdOn: number;
  invitationReSent: boolean;
  mfaMode: MfaMode;
  company: {
    companyName: string;
    orgNumber: string;
    id: string;
    pricePlan: PaymentRole;
    country: Country;
  };
}

export type AdminSorts = 'ASC' | 'DESC';

export function isAdminSorts(u: unknown): u is AdminSorts {
  return u === 'ASC' || u === 'DESC';
}
